module.exports = __webpack_public_path__ + "img/temakiohnehintergrund.7ec4e1d5.png";